import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';
import { PencilIcon } from '@heroicons/react/24/outline';

import { useAppDispatch } from 'src/app/store/hooks';
import { MomentmBrokerAuthRead } from 'src/common/external/bambi-api/bambiApi';

import { adminActions } from '../../admin.slice';

interface MomentmManageCellProps {
  setting: MomentmBrokerAuthRead;
}

export function MomentmManageCell({ setting }: MomentmManageCellProps) {
  const dispatch = useAppDispatch();

  const handleEdit = useCallback(() => {
    dispatch(adminActions.setEditingMomentmSettingsId(setting.id));
    dispatch(adminActions.setShowMomentmSettingsModal(true));
  }, [dispatch, setting.id]);

  return (
    <div className="flex items-center gap-2">
      <Button variant="icon" onClick={handleEdit}>
        <div
          className="flex flex-col items-center text-xs"
          style={{ fontSize: '0.625rem' }}
        >
          <PencilIcon className="w-[24px]" />
          Edit
        </div>
      </Button>
    </div>
  );
}
